
import PaymentViewModel from "./payment.viewmodel";
import moment from "moment";
import { AdditionalPaymentType } from "../../commons/Const";
import { Container } from "./styles";
import { addComma } from "../../utils/Utils";


export default function PaymentPage() {

  const viewModel = PaymentViewModel();

  const {additionalPayment} = viewModel;

  if(additionalPayment === null) return (<></>)

  return (
    <Container className="payment">
      <div className="inner">

        {additionalPayment.type === AdditionalPaymentType.EXTENSION_SUBSCRIPTION && (
          <p>구독연장하기</p>
        )}

        <p className="form_label">상품명</p>
        <strong className="fs20 green">{additionalPayment.type === AdditionalPaymentType.EXTENSION_SUBSCRIPTION ? viewModel.product?.name : additionalPayment.productName}</strong>
        
        {additionalPayment.type === AdditionalPaymentType.EXTENSION_SUBSCRIPTION && (
          <>
            <p className="form_label">구독</p>
            <strong className="fs20 green">{viewModel.subscriptionPeriod}</strong>
          </>
        )}

        <p className="form_label">금액</p>
        <strong className="fs20 green">{addComma(additionalPayment.amount)}원</strong>
        
        <p className="form_label">결제 방법</p>
        <div className="pay_method flex">
          <button
            className={`outlined_gray${viewModel.payMethod === 0 ? ' active' : ''}`}
            onClick={() => viewModel.setPayMethod(0)}
          >신용카드</button>
          <button 
            className={`outlined_gray${viewModel.payMethod === 1 ? ' active' : ''}`}
            disabled={additionalPayment.type === AdditionalPaymentType.EXTENSION_SUBSCRIPTION}
            onClick={() => viewModel.setPayMethod(1)}
          >휴대폰 결제</button>
        </div>

        <button className="contained_main btn_pay fs16"
          onClick={viewModel.order}
        >결제하기</button>
      </div>
    </Container>
  )
}